import * as apis from '../common-utils/api_urls'
import axios from 'axios'
//axios.defaults.withCredentials = true;

/**
 * Auth Service
 * @param {MainWrapper} callingClass 
 */
export default function authentication(callingClass){
  let classCalled=callingClass.calling;
  if(window.sessionStorage.getItem("token")!==null){
    window.sessionStorage.setItem('Name',callingClass.userId);
    classCalled.setAuthToken(window.sessionStorage.getItem("token"), true);
    }else{  
      
    axios(apis.getAuthUrl(),{
      method: 'POST',
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      data: {
        userId: callingClass.userId,
        password: callingClass.userPwd
      }
    })
      .then(
        function(result){
          window.sessionStorage.setItem('token', 'Bearer '+result.data.message.token);
          window.sessionStorage.setItem('Name',callingClass.userId);
          classCalled.setAuthToken('Bearer '+result.data.message.token, true);
        }
      ).catch(
        function (error) {
          console.log('ERROR WHILE AUTHENTICATING');
          console.log(error);
          classCalled.setAuthToken('', false);
        }
      )
  }
}